import { render } from "./page-content-block.vue?vue&type=template&id=54f587f0&ts=true"
import script from "./page-content-block.ts?vue&type=script&lang=ts"
export * from "./page-content-block.ts?vue&type=script&lang=ts"

import "./page-content-block.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__